import { useSearchParams } from "react-router-dom";
import ReactLoading from 'react-loading';
import { useLocation, useNavigate } from "react-router-dom";
import { SortMenu } from "../../../components/SortMenu";
import { useGetTerminalStatusErrorQuery } from "../../../gateways/cms/logApi";
import MainLayout from "../../../layouts/MainLayout";

import { styled } from "@mui/system";
import Stack from "@mui/material/Stack";
import Color from "../../../styles/colors.js";
import VarConst from "../../../styles/variables.js";
import iconReduce from "../../../assets/icons/icon_reduce.svg";

import { useSelector } from "react-redux";
import { selectOrganizationId } from "../../../features/cms/organizationBreadcrumbSlice";
//import { useSetSearchParam, useSetSearchParamArray } from "../../../features/shared/searchParamsExtension";
// style
const PageTitle = styled("section")`
    display: flex;
    justify-content: space-between;
    padding: 24px 0px 4px 24px;
    h1 {
        font-size: 24px;
        font-weight: normal;
        margin: 0;
    }
`;
const PageMain = styled("section")`
    display: flex;
    flex-direction: column;
    padding: 0 24px 0;
    overflow: hidden;
    & > main {
        overflow: auto;
    }
`;
const BarList = styled("section")`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin: 0 36px 16px 0;
    font-size: 14px;
`;
const WrapperSticky = styled("section")`
    position: relative;
    overflow: auto;
    margin-bottom: 24px;
`;
const TableCommon = styled("table")`
    table-layout: fixed;
    border-spacing: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    border-bottom: ${VarConst.border1};
    font-size: 13px;
    thead {
        position: sticky;
        top: 0;
        z-index: 10;
    }

    tr > th,
    tr > td {
        border-top: ${VarConst.border1};
        border-right: ${VarConst.border1};
        line-height: 1.2;

        &.terminalStatus {
            width: 8em;
            min-width: 8em;
            max-width: 8em;
        }
        &.terminalStatus-error {
            width: 8em;
            min-width: 8em;
            max-width: 8em;
            background-color: #FFE3E3;
        }
        &.terminalStatus-null {
            width: 8em;
            min-width: 8em;
            max-width: 8em;
            background-color: #EFE4B0;
        }
        &.terminalStatus-power {
            width: 8em;
            min-width: 8em;
            max-width: 8em;
            background-color: #EFE4B0;
        }
        &.organizationName {
            width: 15em;
            min-width: 15em;
            max-width: 15em;
        }
        &.terminalId {
            width: 3em;
            min-width: 3em;
            max-width: 3em;
        }
        &.terminalName {
            width: 15em;
            min-width: 15em;
            max-width: 15em;
        }
        &.terminalName-body {
            width: 15em;
            min-width: 15em;
            max-width: 15em;
            text-decoration:underline;
            text-underline-position: under;
            text-decoration-color: darkgray;
        }
        &.message {
            width: 30em;
            min-width: 30em;
            max-width: 30em;
            white-space: pre-line;
        }
        &.memo {
            width: 20em;
            min-width: 20em;
            max-width: 20em;
        }
        &.updatedAt {
            width: 8em;
            min-width: 8em;
            max-width: 8em;
        }
    }
    tr > th {
        padding: 4px 0 4px 8px;
        background-color: ${Color.bgHead};
        text-align: left;
        font-weight: normal;
        border-bottom: ${VarConst.border1};

        &.function {
            text-align: center;
            padding: 0;
            position: sticky;
            right: 0;
        }
    }
    tr > td {
        padding: 6px 8px;
        ul {
            /* display: flex; */
            li {
                display: inline;
            }
            li + li::before {
                content: ", ";
            }
        }
        &.function {
            padding-top: 12px;
            padding-bottom: 12px;
            position: sticky;
            right: 0;
            z-index: 1;
            background-color: #fff;
        }
    }

    // 状態表示
    tr {
        .status div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 2em;
            margin: 0 auto;
            color: #fff;
            line-height: 1;

            b {
                writing-mode: vertical-lr;
                font-weight: normal;
            }
        }
    }
`;

const FunctionHeader = styled("section")`
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
        flex: 1;
        font-weight: normal;
    }

    &.reduce button {
        background-image: url(${iconReduce});
    }
`;
const Loading = styled("section")`
    position: relative;
    left: 45%;
    top: 35%;
    b {
        font-size: 12px;
        color: #A9A9A9;
        font-weight: normal;
    }
`;    

export function TerminalStatusErrorListPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    //const setSearchParam = useSetSearchParam(searchParams, setSearchParams);
    //const setSearchParamArray = useSetSearchParamArray(searchParams, setSearchParams);
    const location = useLocation();
    const navigate = useNavigate();
    const organizationId = useSelector(selectOrganizationId);

    const errorTerminals = useGetTerminalStatusErrorQuery({
        organizationId: organizationId || undefined,
        sort_key: searchParams.get("sort_key") || undefined,
        sort_direction: searchParams.get("sort_direction") || undefined,
    })

    const handleSortBy = (key: string, direction: string) => () => {
        const next = new URLSearchParams(searchParams); // ← 新しいインスタンス
        next.set("sort_key", key);
        next.set("sort_direction", direction);
        setSearchParams(next);
    }

    const handleDetail = (terminalId: number, organizationId: number) => () => {
        navigate(`/organizations/${organizationId}/terminals/${terminalId}/detail`, {
            state: { backgroundLocation: location },
        })
    }

    const getStatusClass = (terminalStatus: number) => {
        if(terminalStatus === 1) return "terminalStatus-error";
        else if(terminalStatus === 2) return "terminalStatus-null";
        else if(terminalStatus === 3) return "terminalStatus-power";
        else return "terminalStatus";
    }

    const getStatusMessage = (terminalStatus: number) => {
        if(terminalStatus === 1) return "通信異常";
        else if(terminalStatus === 2) return "モニター制御異常";
        else if(terminalStatus === 3) return "モニター制御異常";
        else return "不明";
    }


    if (errorTerminals.isFetching) {
        return (
            <MainLayout title="異常端末管理">
                <Loading>
                    <ReactLoading type="bars" color="#ADD8E6" height={'-1%'} width={'8%'} />
                    <b>異常端末データ取得中</b>
                </Loading>
            </MainLayout>
        );
    };

    return (
        <MainLayout title="異常端末管理">
            <PageTitle>
                <h1>異常端末管理</h1>
            </PageTitle>

            <PageMain>
                <BarList>
                    <Stack spacing={1} direction="row">
                        <span> 異常発生件数: {errorTerminals.data?.length} 件 </span>
                    </Stack>
                </BarList>
                <WrapperSticky>
                    <TableCommon>
                        <thead>
                            <tr>
                                
                                <th className="terminalStatus">
                                    <FunctionHeader className={`${ searchParams.getAll("terminalStatus").length > 0 && "reduce"}`}>
                                        <b>状態</b>
                                        <SortMenu
                                            menuAsc={
                                                <button type="button" onClick={handleSortBy("terminalStatus", "asc")}>
                                                    通信異常→制御異常
                                                </button>
                                            }
                                            menuDesc={
                                                <button type="button" onClick={handleSortBy("terminalStatus", "desc")}>
                                                    制御異常→通信異常
                                                </button>
                                            }
                                        />
                                    </FunctionHeader>
                                </th>
                                <th className="organizationName">
                                    <FunctionHeader>
                                        <b>テナント</b>
                                    </FunctionHeader>
                                </th>
                                <th className="terminalId">
                                    <FunctionHeader className={`${ searchParams.getAll("terminalId").length > 0 && "reduce"}`}>
                                        <b>ID</b>
                                        <SortMenu
                                            menuAsc={
                                                <button type="button" onClick={handleSortBy("terminalId", "asc")}>
                                                    昇順 ( 1→99 )
                                                </button>
                                            }
                                            menuDesc={
                                                <button type="button" onClick={handleSortBy("terminalId", "desc")}>
                                                    降順 ( 99→1 )
                                                </button>
                                            }
                                        />
                                    </FunctionHeader>
                                </th>
                                <th className="terminalName">
                                    <FunctionHeader>
                                        <b>端末名</b>
                                    </FunctionHeader>
                                </th>
                                <th className="message">
                                    <FunctionHeader>
                                        <b>ステータス</b>
                                    </FunctionHeader>
                                </th>
                                <th className="memo">
                                    <FunctionHeader>
                                        <b>メモ</b>
                                    </FunctionHeader>
                                </th>
                                <th className="updatedAt">
                                    <FunctionHeader>
                                        <b>更新日時</b>
                                        <SortMenu
                                            menuAsc={
                                                <button type="button" onClick={handleSortBy("updatedAt", "asc")}>
                                                    昇順 ( 古→新 )
                                                </button>
                                            }
                                            menuDesc={
                                                <button type="button" onClick={handleSortBy("updatedAt", "desc")}>
                                                    降順 ( 新→古 )
                                                </button>
                                            }
                                        />
                                    </FunctionHeader>
                                </th>
                                

                            </tr>
                        </thead>
                        <tbody>
                        {errorTerminals.data?.map((errorTerminal) => (
                            <tr>
                                <td className={getStatusClass(errorTerminal.terminalStatus)}>
                                    {getStatusMessage(errorTerminal.terminalStatus)}
                                </td>
                                <td className="organizationName">{errorTerminal.organizationName}</td>
                                <td className="terminalId">{errorTerminal.terminalId}</td>
                                <td className="terminalName-body" 
                                    onClick={handleDetail(errorTerminal.terminalId, errorTerminal.organizationId)}>
                                        {errorTerminal.terminalName}
                                </td>
                                <td className="message">{errorTerminal.message}</td>
                                <td className="memo">{errorTerminal.memo}</td>
                                <td className="updatedAt">{errorTerminal.updatedAt}</td>
                            </tr>
                        ))}
                        </tbody>
                    </TableCommon>
                </WrapperSticky>
            </PageMain>
        </MainLayout>
    );
}